//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'

export default {
  name: 'clotheStatus',
    components: {
        wx
    },
  data () {
    return {
      code:'',
      info:{},
    }
  },
  created(){
     this.sign();
  },
  mounted(){
   
  },
  methods:{
    clotheStatus(){
      if(!this.code || this.code.length != 12){
        this.$func.showToast('条码无效');
        return ;
      }
      this.$api.clotheStatus({code:this.code}).then((res)=>{
        if(res){
          if(res.data){
            this.info = res.data;
          }else{
            this.$func.showToast('无信息');
          }
        }
      })  
    },
    scanQRCode(){
      let that = this;
      wx.ready(()=> {
        wx.scanQRCode({
          needResult: 1,
          scanType: ["qrCode","barCode"],
          success: function (res) {
            setTimeout(()=>{
                that.code = that.$func.parseScanResult(res.resultStr);
            },300);
          }
        })
      });
      wx.error((res)=> {
        console.log(res)
        // alert(res.errMsg);
      })
    },  
    sign(){
      let url = (window.location.href).split('#');
      if(url[0].indexOf('?') != '-1'){
        url = url[0].split('?');
      }
      this.$api.wxSign({url:url[0]}).then((res)=>{
        wx.config({
            debug: false, // 开启调试模式,
            appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature,// 必填，签名，见附录1
            jsApiList: res.data.jsApiList || ['scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/clotheStatus.vue